import FJAIAudioLeft from '../view/FJAIAudioLeft.jsx';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJActionAIAudioGenerator from '../../../../redux/action/FJActionAIAudioGenerator.js';
import { useMemo, useEffect } from 'react';
import useDefaultFreeLimit from '../../../../hooks/useDefaultFreeLimit.jsx';

const FJAIAudioLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const tabIndex = useSelector(state => state.AIAudioGenerator.tabIndex);
    const subTabIndex = useSelector(state => state.AIAudioGenerator.subTabIndex);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const creditNumber = useSelector(state => state.common.creditNumber);

    const textToMusicFreeNum = useSelector(state => state.AIAudioGenerator.textToMusicFreeNum);
    const textToAccompanyFreeNum = useSelector(state => state.AIAudioGenerator.textToAccompanyFreeNum);
    const musicToMusicFreeNum = useSelector(state => state.AIAudioGenerator.musicToMusicFreeNum);
    const musicToInstFreeNum = useSelector(state => state.AIAudioGenerator.musicToInstFreeNum);
    const sfxFreeNum = useSelector(state => state.AIAudioGenerator.sfxFreeNum);

    const freeNumCreation = useMemo(() => {
        if (tabIndex === 0) {
            // T2M 模式
            return subTabIndex === 0 ? textToMusicFreeNum : textToAccompanyFreeNum;
        } else if (tabIndex === 1) {
            // M2M 模式
            return subTabIndex === 0 ? musicToMusicFreeNum : musicToInstFreeNum;
        } else if (tabIndex === 2) {
            // SFX 模式
            return sfxFreeNum;
        }
        return 0;
    }, [
        tabIndex,
        subTabIndex,
        textToMusicFreeNum,
        textToAccompanyFreeNum,
        musicToMusicFreeNum,
        musicToInstFreeNum,
        sfxFreeNum,
    ]);

    const freeLimitType = useMemo(() => {
        if (tabIndex === 0) {
            // T2M 模式
            return subTabIndex === 0 ? 'text-to-music' : 'text-to-accompany';
        } else if (tabIndex === 1) {
            // M2M 模式
            return subTabIndex === 0 ? 'music-generator' : 'audio-accompany-generator';
        } else if (tabIndex === 2) {
            // SFX 模式
            return 'audio-effect-generator';
        }
        return undefined;
    }, [tabIndex, subTabIndex]);
    const defaultFreeNumCreation = useDefaultFreeLimit(freeLimitType);

    const prompt = useSelector(state => state.AIAudioGenerator.sfxPrompt);

    useEffect(() => {
        dispatch(FJActionAIAudioGenerator.initAIAudioGeneratorAction());
    }, [dispatch]);

    const onGenerate = useCallback(() => {
        dispatch(FJActionAIAudioGenerator.onGenerateAction());
    }, [dispatch]);

    const onChangePrompt = value => {
        dispatch(FJActionAIAudioGenerator.changeSFXPromptAction(value));
    };

    const getInspire = () => {
        dispatch(FJActionAIAudioGenerator.getInspireAction());
    };

    return (
        <FJAIAudioLeft
            tabIndex={tabIndex}
            onGenerate={onGenerate}
            taskStatus={taskStatus}
            isProjectLoading={isProjectLoading}
            freeNumCreation={freeNumCreation}
            creditNumber={creditNumber}
            prompt={prompt}
            onChangePrompt={onChangePrompt}
            getInspire={getInspire}
            defaultFreeNumCreation={defaultFreeNumCreation}
        />
    );
};
export default FJAIAudioLeftContainer;
